<template>
  <div class="my-3" v-if="isVisible">

<label class="mb-1" v-if="question.formKeys[0] == 'disclaimer'" :for="`field_${field.form_key}`" v-html="privacyPolicy" :class="{ 'required' : field.required === 1, 'field-error-message': question.hasError }"></label>
<label class="mb-1" v-else :for="`field_${field.form_key}`" :class="{ 'required' : field.required === 1, 'field-error-message': question.hasError }">
    {{ question.question}}
</label>
<p class="mb-2 small" v-if="question.note" :class="{ 'field-error-message': question.hasError }">
  {{ question.note }}
</p>
<p v-if="question.hasError" class="mb-2" :class="{ 'field-error-message': question.hasError }">
  {{ question.errorMsg }}
</p>
<div class="btn-group btn-group-toggle d-flex mb-3" role="group" data-toggle="buttons">

        <label class="btn btn-outline-blue2 w-100 mb-3" :class="{ 'active': answer == '1' }"
               @click="changeSelectVal(1)"
        >
          <input type="radio" :id="field.form_key + '-yes'" :name="field.form_key" :ref="'field_' + field.form_key"
                 value="1" :tabIndex="question.id" autocomplete="off" v-model="answer"
                 @focus="$emit('questionSelected', question.order)"
          >
          Yes
        </label>
        <label class="btn btn-outline-blue2 w-100 mb-3" :class="{ 'active': answer == '0' }"
               @click="changeSelectVal(0)"
        >
          <input type="radio" :id="field.form_key + '-no'" :name="field.form_key"
                  value="0" :tabIndex="question.id" autocomplete="off" v-model="answer"
                 @focus="$emit('questionSelected', question.order)"
          >
          No
        </label>
      </div>

  </div>
</template>

<script>

import elementMixins from '../mixins/elements'

export default {
  name: 'LUCheckbox',
  mixins: [elementMixins],
  methods: {
    changeSelectVal: function (val) {
      this.answer = val
    }
  },
  computed: {
    privacyPolicy: function () {
      return 'I agree to the terms & conditions stated in the <a href="/privacy-policy" target="_blank" >Privacy Policy.</a>';
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// resources/assets/js/frontend-vue/components/forms/elements/Checkbox.vue